import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import {
  Description,
  TableChart,
} from '@mui/icons-material';
import FileUpload from '../components/FileUpload';
import ProcessStatus from '../components/ProcessStatus';

const UploadPage: React.FC = () => {
  const handleDocumentationUpload = (response: any) => {
    console.log('Documentation uploaded:', response);
  };

  const handleRegulationUpload = (response: any) => {
    console.log('Regulation uploaded:', response);
  };

  const handleUploadError = (error: string) => {
    console.error('Upload error:', error);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Upload & Process
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Upload your documentation (PDF) and regulation (Excel) files, then run the compliance analysis.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', lg: 'row' } }}>
        <Box sx={{ flex: '0 0 66%' }}>
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              File Uploads
            </Typography>
            
            <FileUpload
              accept="application/pdf"
              endpoint="/api/upload/documentation"
              title="Documentation (PDF)"
              description="Upload your airline documentation PDF file"
              icon={<Description color="primary" />}
              onUploadSuccess={handleDocumentationUpload}
              onUploadError={handleUploadError}
            />

            <FileUpload
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              endpoint="/api/upload/regulation"
              title="Regulation (Excel)"
              description="Upload your regulation points Excel file"
              icon={<TableChart color="primary" />}
              onUploadSuccess={handleRegulationUpload}
              onUploadError={handleUploadError}
            />
          </Paper>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Paper sx={{ p: 3, position: 'sticky', top: 20 }}>
            <Typography variant="h6" gutterBottom>
              Process Overview
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              The compliance analysis process includes:
            </Typography>
            <Box component="ol" sx={{ pl: 2, m: 0 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                <strong>Documentation Processing:</strong> Extract and chunk PDF content
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                <strong>Regulation Processing:</strong> Parse Excel regulation points
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                <strong>Vector Search:</strong> Find relevant document sections
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                <strong>LLM Analysis:</strong> Compare documents against regulations
              </Typography>
              <Typography component="li" variant="body2">
                <strong>Results:</strong> Generate compliance report
              </Typography>
            </Box>
          </Paper>
        </Box>
      </Box>

      <ProcessStatus />
    </Container>
  );
};

export default UploadPage;